import { render, staticRenderFns } from "./ConfigurationSalesGroups.vue?vue&type=template&id=0cf65c94&scoped=true&"
import script from "./ConfigurationSalesGroups.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSalesGroups.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSalesGroups.vue?vue&type=style&index=0&id=0cf65c94&prod&lang=scss&scoped=true&"
import style1 from "./ConfigurationSalesGroups.vue?vue&type=style&index=1&id=0cf65c94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf65c94",
  null
  
)

export default component.exports